import {BillingAccountInfoState} from "./states/billing-account-info.state";
import {BillingTransactionsState} from "./states/billing-transactions.state";
import {BillingInvoiceState} from "./states/billing-invoice.state";

export const billingState = [
    BillingAccountInfoState,
    BillingTransactionsState,
    BillingInvoiceState
];
